<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <!-- {{ selection }}<br /> -->
    <b-card class="standardpage reports border-none">
      <b-card-header id="carstats-card-header" class="pl-2 pr-3 small">
        <b-row align-v="center">
          <b-col class="mb-2 mb-sm-0">Order Expenditures</b-col>
          <b-col cols="auto" class="mb-2 mb-sm-0">
            <b-form-group size="sm" class="mb-0">
              <b-input-group>
                <b-form-input
                  size="sm"
                  v-model="yourref"
                  placeholder="Find"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    style="width: auto; padding: 0.25rem 0.6rem"
                    variant="outline-primary"
                    :disabled="!yourref"
                    @click="yourref = ''"
                  >
                    <i v-if="yourref" class="fa fa-remove"></i>
                    <i v-if="!yourref" class="fa fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group> </b-form-group
          ></b-col>
          <b-col cols="auto" class="mb-2 mb-sm-0">
            <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-clock"></i>
              </template>
              <b-dropdown-item
                v-for="timerange in timeranges"
                :key="timerange"
                @click="handleUpdate(timerange)"
                >{{ timerange }}</b-dropdown-item
              >
            </b-dropdown>
            <div class="mb-0 text-right pr-4">In the last: {{ timerange }}</div>
          </b-col></b-row
        >
      </b-card-header>

      <b-card-group deck class="mt-2">
        <b-row no-gutters class="w-100pct">
          <b-col
            :cols="cards"
            v-for="(order, index) in items"
            :key="index"
            class="mb-2"
          >
            <b-card no-body>
              <b-card-header class="text-center bg-light">
                <div
                  class="overspent"
                  v-if="parseFloat(order.value) - parseFloat(order.spent) < 0"
                >
                  <span>Overspent</span>
                </div>
                <!-- <span class="small">
                  <span class="h6 text-primary" v-if="order.eventcode">
                    {{ order.eventname }}<br />
                  </span>
                  Ref: {{ order.yourref }}, <br />Date: {{ order.dateplaced }}
                </span> -->
                <div v-if="order.yourref" title="Your Ref">
                  Your Ref: {{ order.yourref }}
                </div>
                <!-- <b-row
                  align-v="center"
                  no-gutters
                  class="justify-content-md-left text-dark"
                >
                  <b-col cols="auto mr-3"
                    ><i class="fa fa-gavel fa-3x"></i
                  ></b-col>
                  <b-col cols="auto" class="text-left">
                    <div class="h4 text-primary strong" title="Your Ref / PO">
                      {{ order.yourref }}
                    </div>

                    <div class="small" title="Date Placed">
                      {{ order.dateplaced }}
                    </div>
                  </b-col>
                </b-row> -->
              </b-card-header>
              <b-card-body>
                <!-- <b-card-title
                  ><i class="fa fa-gavel"></i> Your Ref: {{ order.yourref }}
                  <br />
                </b-card-title> -->
                <b-card-text class="text-center">
                  {{ order.eventname }}</b-card-text
                >
                <!-- <b-card-text> Placed: {{ order.dateplaced }}</b-card-text> -->
                <OrderPie v-if="order.tile" :tile="order.tile" />
              </b-card-body>
              <!-- <b-card-footer class="text-center mt-3">
                <span
                  >Value:
                  <span class="text-primary">{{
                    order.valuetotal | currency("£")
                  }}</span
                  >, Spent:
                  <span class="text-danger">{{
                    order.saletotal | currency("£")
                  }}</span>
                </span>
              </b-card-footer> -->
              <b-card-footer class="border-none">
                <b-row v-if="legend" class="mt-2 pl-2 eventcalendar">
                  <b-col cols="auto" class="legend mb-3">
                    <b-row align-v="center" no-gutters>
                      <b-col class="text-dark">
                        <b-row>
                          <b-col>
                            <div
                              class="inline mt-1 border-secondary bg-dark mr-1"
                            ></div>
                            <span>TOTAL</span></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col class="text-center"
                            ><span>{{
                              order.value | currency("£")
                            }}</span></b-col
                          >
                        </b-row>

                        <br />
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="auto" class="legend mb-3">
                    <b-row align-v="center" no-gutters>
                      <b-col>
                        <b-row>
                          <b-col>
                            <div class="inline">
                              <div
                                class="
                                  inline
                                  mt-1
                                  border-secondary
                                  bg-primary
                                  mr-1
                                "
                              ></div>
                              <span class="text-primary">INVOICE</span>
                            </div>
                            <div class="inline mx-1"><span>+</span></div>
                            <div class="inline">
                              <div
                                class="
                                  inline
                                  mt-1
                                  border-secondary
                                  bg-danger
                                  mr-1
                                "
                              ></div>
                              <span class="text-danger">CREDIT</span>
                            </div></b-col
                          >
                        </b-row>

                        <b-row>
                          <b-col class="text-center">
                            <span class="text-primary">{{
                              order.spent | currency("£")
                            }}</span></b-col
                          >
                        </b-row>

                        <br />
                      </b-col>
                    </b-row>
                  </b-col>

                  <!-- <b-col
                    cols="auto"
                    class="legend mb-3"
                    v-if="order.tile.data.raw.find((k) => k.key.includes('CM'))"
                  >
                    <b-row align-v="center" no-gutters>
                      <b-col cols="auto mr-2">
                        <div
                          class="inline mt-1 border-secondary bg-danger"
                        ></div>
                      </b-col>
                      <b-col class="text-danger">
                        <span>CREDIT</span><br />
                        <span>{{ order.spent | currency("£") }}</span></b-col
                      >
                    </b-row>
                  </b-col> -->

                  <b-col
                    cols="auto"
                    class="legend mb-3"
                    v-if="order.tile.data.raw.find((k) => k.key == 'Forecast')"
                  >
                    <b-row align-v="center" no-gutters>
                      <b-col class="text-purple">
                        <b-row>
                          <b-col>
                            <div
                              class="
                                inline
                                mt-1
                                border-secondary
                                bg-purple
                                mr-1
                              "
                            ></div>
                            <span>FORECAST</span></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col class="text-center">
                            <span>{{
                              order.forecast | currency("£")
                            }}</span></b-col
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>

                  <!-- v-if="order.tile.data.raw.find((k) => k.key == 'Remaining')" -->
                  <b-col
                    cols="auto"
                    class="legend mb-3"
                    v-if="parseFloat(order.remaining) > 0"
                  >
                    <b-row align-v="center" no-gutters>
                      <b-col class="text-warning">
                        <b-row>
                          <b-col>
                            <div
                              class="
                                inline
                                mt-1
                                border-secondary
                                bg-warning
                                mr-1
                              "
                            ></div>
                            <span>REMAINING</span></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col class="text-center">
                            <span>{{
                              order.remaining | currency("£")
                            }}</span></b-col
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col
                    cols="auto"
                    class="legend mb-3"
                    v-if="parseFloat(order.remaining) < 0"
                  >
                    <b-row align-v="center" no-gutters>
                      <b-col class="text-dark">
                        <b-row>
                          <b-col>
                            <div
                              class="inline mt-1 border-secondary bg-dark mr-1"
                            ></div>
                            <span>OVERSPENT</span></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col class="text-center">
                            <span>{{
                              order.remaining | currency("£")
                            }}</span></b-col
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card-footer>
            </b-card>
          </b-col>
        </b-row>
      </b-card-group>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <!-- <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col> -->
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>


<script>
import gql from "graphql-tag";

import OrderPie from "../../private/Tiles/OrderPie.vue";
//import shortid from "shortid";

export default {
  name: "OrdersSpend",
  props: ["tile", "refresh"],
  components: {
    OrderPie,
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    async yourref() {
      await this.loadChart();
    },
  },
  data() {
    return {
      busy: false,
      legend:true,
      timeout: false,
      timerange: "90 days",
      timeranges: ["30 days", "60 days", "90 days", "180 days", "365 days"],
      //chartId: shortid.generate(),
      dateplacedfrom: this.$moment().add(-3, "months").format("YYYY-MM-DD"),
      dateplacedto: this.$moment().format("YYYY-MM-DD"),
      slac: null,
      status: "1",
      yourref: null,
       find: "",
      items: [],
      options: {
        debounce: 500,
      },
    };
  },
  computed: {
   cards() {
      if (this.items.length <= 2) {
        return 6;
      }
      if (this.window.width < 500) {
        return 12;
      } else if (this.window.width < 800) {
        return 6;
      } else if (this.window.width < 1200) {
        return 4;
      } else {
        return 4;
      }
    },
  },
  methods: {
    async loadChart() {
      this.busy = true;

      this.items = [];

      switch (this.timerange) {
        case "30 days":
          this.dateplacedfrom = this.$moment()
            .add(-30, "days")
            .format("YYYY-MM-DD");
          break;
        case "60 days":
          this.dateplacedfrom = this.$moment()
            .add(-60, "days")
            .format("YYYY-MM-DD");
          break;
        case "90 days":
          this.dateplacedfrom = this.$moment()
            .add(-90, "days")
            .format("YYYY-MM-DD");
          break;
        case "180 days":
          this.dateplacedfrom = this.$moment()
            .add(-180, "days")
            .format("YYYY-MM-DD");
          break;
        case "365 days":
          this.dateplacedfrom = this.$moment()
            .add(-365, "days")
            .format("YYYY-MM-DD");
          break;
      }

      if (this.user.rolename == "client") {
        this.slac = this.user.slac;
      }
      // FIRSTLY GET A LIST OF ORDERS TO DISPLAY
      let variables = {
        dateplaced_at: [this.dateplacedfrom, this.dateplacedto],
        yourref: this.yourref,
        slac: this.slac,
        status: this.status,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      const response = await this.$apollo.query({
        query: gql`
          query orders(
            $id: String
            $yourref: String
            $dateplaced_at: [String]
            $slac: String
            $eventcode: String
            $agent: String
            $status: String
            $dateformat: String
          ) {
            orders(
              id: $id
              yourref: $yourref
              dateplaced_at: $dateplaced_at
              slac: $slac
              eventcode: $eventcode
              agent: $agent
              status: $status
              dateformat: $dateformat
            ) {
              id
              yourref
              slac
              reason
              dateplaced
              eventcode
              eventname
              value
              spent
              forecast
              remaining
              status
              attachment
              agent
            }
          }
        `,
        variables,
      });

      this.items = response.data.orders;

      // NOW WE HAVE A SELECTION MAKE THE DONUT CALL
      for (var k = 0; k < this.items.length; k++) {
        let item = { ...this.items[k] };

        let variables = {
          yourref: item.yourref,
          slac: item.slac,
          eventcode: item.eventcode,
        };

        console.log("variables", variables);
        try {
          const response = await this.$apollo.query({
            query: gql`
              query chart_orderspent(
                $eventcode: String
                $yourref: String
                $slac: String
              ) {
                chart_orderspent(
                  eventcode: $eventcode
                  yourref: $yourref
                  slac: $slac
                ) {
                  labels
                  datasets {
                    data
                  }
                  raw {
                    key
                    value
                  }
                }
              }
            `,
            variables,
          });
          if (response.data.chart_orderspent) {
            try {
              item.tile = {
                settings: [
                  {
                    key: "type",
                    label: "Chart Type",
                    type: "radio-group",
                    buttons: true,
                    "button-variant": "outline-primary",
                    values: [
                      { value: "horizontalbar", text: "Horizontal Bar" },
                    ],
                    value: "donut",
                  },
                  {
                    key: "server",
                    label: "Server",
                    type: "radio-group",
                    buttons: true,
                    "button-variant": "outline-primary",
                    values: [{ value: "LIVE", text: "LIVE" }],
                    value: "LIVE",
                  },
                  {
                    key: "title",
                    label: "Title",
                    type: "radio-group",
                    buttons: true,
                    "button-variant": "outline-primary",
                    values: [
                      { value: true, text: "On" },
                      { value: false, text: "Off" },
                    ],
                    value: false,
                    tab: "Annotate",
                  },
                  {
                    key: "titletext",
                    label: "Title Text",
                    type: "text",
                    value: "",
                    tab: "Annotate",
                  },
                  {
                    key: "holetext",
                    label: "Hole Text",
                    type: "text",
                    value: this.$options.filters.currency(item.value, "£"),
                    tab: "Annotate",
                  },
                  {
                    key: "legend",
                    label: "Legend",
                    type: "radio-group",
                    buttons: true,
                    "button-variant": "outline-primary",
                    values: [
                      { value: true, text: "On" },
                      { value: false, text: "Off" },
                    ],
                    value: false,
                    tab: "Annotate",
                  },
                  {
                    key: "legendposition",
                    label: "Legend Position",
                    type: "radio-group",
                    buttons: true,
                    "button-variant": "outline-primary",
                    values: [
                      { value: "top", text: "Top" },
                      { value: "bottom", text: "Bottom" },
                      { value: "left", text: "Left" },
                      { value: "right", text: "Right" },
                    ],
                    value: "bottom",
                    tab: "Annotate",
                  },
                  {
                    key: "datalabels",
                    label: "Data Labels",
                    type: "radio-group",
                    buttons: true,
                    "button-variant": "outline-primary",
                    values: [
                      { value: true, text: "On" },
                      { value: false, text: "Off" },
                    ],
                    value: false,
                    tab: "Annotate",
                  },
                  {
                    key: "titlefontnamesize",
                    label: "",
                    label_type: "Font Type",
                    label_size: "Font Size",
                    type: "fontsize",
                    values_type: [
                      { value: "Arial", text: "Arial" },
                      { value: "Helvetica Neue", text: "Helvetica Neue" },
                    ],
                    values_size: [
                      { value: "10", text: "10" },
                      { value: "12", text: "12" },
                      { value: "14", text: "14" },
                    ],
                    tab: "Fonts",
                  },
                ],
                options: {
                  actions: [
                    {
                      key: "settings",
                      label: "Settings",
                      icon: "fa fa fa-cog text-primary",
                    },
                    { divider: true },
                    {
                      key: "small",
                      label: "Small",
                      icon: "fa fa-th text-primary",
                    },
                    {
                      key: "large",
                      label: "Large",
                      icon: "fa fa-square text-primary",
                    },
                    { divider: true },
                    {
                      key: "delete",
                      label: "Delete",
                      icon: "fa fa-trash text-danger",
                    },
                  ],
                },
                data: response.data.chart_orderspent,
              };
              
              this.items[k].tile = item.tile;
            } catch (error) {}
          }
        } catch (error) {
          console.log(error);
        }
      }

      this.busy = false;
    },
    async handleUpdate(update) {
      console.log("handleUpdate", update);
      this.timerange = update;
      await this.loadChart();
    },
  },
};
</script>

<style>
</style>